import { ParsedField } from '@/components/Questionnaire/form/helpers/parseFieldKey';

/*
 * Only need to run on the first row of each list, the agent calculates all line numbers after the current row.
 */
const pickRowsToRun = (allOutputs: ParsedField[]): ParsedField[] => {
  const onlyFirstRows: ParsedField[] = [];
  const listIndexes: Record<string, number> = {};

  // Loop through all outputs and pick the first row of each list
  // When running the line number agent all rows after the current row are also calculated
  for (let i = 0; i < allOutputs.length; i += 1) {
    const thisOutput = allOutputs[i];
    if (!thisOutput.listFieldKey || thisOutput.rowIndex === null) {
      onlyFirstRows.push(thisOutput);
    } else {
      const thisListIndex: number | undefined = listIndexes[thisOutput.listFieldKey];
      if (thisListIndex === undefined) {
        onlyFirstRows.push(thisOutput);
        listIndexes[thisOutput.listFieldKey] = onlyFirstRows.length - 1;
      } else {
        const thisOutputRowIndex = thisOutput?.rowIndex ?? null;
        const currentOutputRowIndex = onlyFirstRows?.[thisListIndex]?.rowIndex ?? null;
        if (
          thisOutputRowIndex !== null
          && currentOutputRowIndex !== null
          && thisOutputRowIndex < currentOutputRowIndex
        ) {
          onlyFirstRows[thisListIndex] = thisOutput;
        }
      }
    }
  }

  return onlyFirstRows;
};

export default pickRowsToRun;